import ilComponent from './Evidence'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}

